import React from "react";
import { Link, useNavigate } from "react-router-dom";
import lightLogo from "../assets/images/light-logo.svg";
import useWindowSize from "../hooks/window/useWindowSize";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "../components";
import moment from "moment";
import { isEnglish } from "../utils/utils";
import i18n from "../i18n";
import arrow from "../assets/images/icons/chevron-right.svg";

interface AuthLayoutProps {
  title: string;
  description?: string | React.ReactNode;
  lottieImage?: React.ReactNode;
  children: React.ReactNode;
  isWithLoginLink?: boolean;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  title,
  description,
  children,
  lottieImage: lottieImg,
  isWithLoginLink,
}) => {
  const { width } = useWindowSize();

  const { t } = useTranslation();
  const isLargeScreen = width > 1024;

  const navigate = useNavigate();
  return (
    <div className="flex h-screen flex-col items-center justify-end gap-8 bg-white p-3 lg:flex-row lg:justify-between lg:p-6 xl:gap-0">
      <div className="loginBg flex h-screen max-h-80 w-full items-center justify-center rounded-xl bg-cover bg-center lg:h-full lg:max-h-[calc(100dvh-3rem)] lg:max-w-[50vw]">
        {" "}
        {!isLargeScreen && (
          <div className="absolute start-5 top-5 z-[8]">
            <LanguageSwitcher />
          </div>
        )}
        {/* {lottieImg} */}
        <img src={lightLogo} alt="Logo" className="max-w-[30%]" />
      </div>
      <div className="flex h-full w-full max-w-lg flex-col items-center gap-4 px-2 lg:min-w-[50vw] lg:justify-between lg:px-0 lg:py-6">
        <div className="flex h-full min-w-[28rem] flex-col items-center justify-between">
          {isLargeScreen && (
            <div className="flex w-full justify-end">
              <LanguageSwitcher />
            </div>
          )}

          <div className="flex w-full max-w-[95dvw] flex-col items-start gap-6 md:max-w-xl">
            {/* <img src={logo} alt="Logo" className="w-52" /> */}
            {isWithLoginLink && (
              <Link to="/login" className="mt-4 flex items-center gap-2">
                <img
                  src={arrow}
                  className={`h-6 w-6 ${isEnglish(i18n.language) ? "rotate-180" : ""}`}
                  alt=""
                />
                {t("return_to_login")}
              </Link>
            )}
            <div className="flex flex-col gap-2">
              <h2 className="text-2xl font-bold max-sm:text-xl">{title}</h2>
              {description && (
                <p className="text-body-text text-base font-normal">
                  {description}
                </p>
              )}
            </div>
            <div className="w-full">{children}</div>
          </div>

          <div className="flex flex-col items-center justify-end gap-4 lg:flex-row lg:justify-between">
            <p className="text-body-text">
              {t("all_rights_reserved", {
                date: moment().locale("en").format("YYYY"),
              })}
            </p>
            <button
              onClick={() => {
                navigate(`/privacy_policy`);
              }}
              className="cursor-pointer font-bold text-secondary underline"
            >
              {t("privacy_policy")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
